export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/common-area/resources/components.js